import { getTokens } from 'config/tokens'
import useWallet from 'rfx/lib/wallets/useWallet'
import { useMemo } from 'react'

const useActiveChainTokens = () => {
  const { chainId } = useWallet()
  return useMemo(
    () => getTokens(chainId).filter((item) => !!item.storkID),
    [chainId],
  )
}

export default useActiveChainTokens
